import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 407.436 407.436" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M112.814 0L91.566 21.178l181.946 182.54-181.946 182.54 21.248 21.178 203.055-203.718z" /></svg>;